import { render, staticRenderFns } from "./schoolSeeing.vue?vue&type=template&id=808f9044"
import script from "./schoolSeeing.vue?vue&type=script&lang=js"
export * from "./schoolSeeing.vue?vue&type=script&lang=js"
import style0 from "./schoolSeeing.vue?vue&type=style&index=0&id=808f9044&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports